import React from "react";
import NavBarThree from "../NavBarThree";
import { useSearchParams } from "react-router-dom";
import { CloseOutlined, SortAscendingOutlined, SortDescendingOutlined } from "@ant-design/icons";

interface ItemInterface {
  name: string;
  key: string;
  sort?: 'asc' | 'desc';
}

export interface OrderByInterface {
  items: ItemInterface[];
  defaultKey?: string;
  defaultSort?: 'asc' | 'desc';
}

const OrderBy = ({ items, defaultKey, defaultSort = 'desc' }: OrderByInterface) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const orderBy     = searchParams.get('order_by') || defaultKey;
  const orderSort   = searchParams.get('order') || defaultSort;

  function onClick(item: ItemInterface) {
    let order: string;

    if (orderBy === item.key) {
      order = orderSort === 'desc' ? 'asc' : 'desc';
    } else {
      order = item.sort || defaultSort;
    }

    if (searchParams.get('page')) {
      searchParams.set('page', '1');
    }

    searchParams.set('order_by',  item.key);
    searchParams.set('order',     order);
    setSearchParams(searchParams, { replace: true });
  }

  function clear() {
    searchParams.delete('order_by');
    searchParams.delete('order');
    setSearchParams(searchParams, { replace: true });
  }

  const renderFilterItem = (item: ItemInterface) => {
    const active = isActive(item.key);
    const icon = orderSort === 'asc' ? <SortAscendingOutlined /> : <SortDescendingOutlined />;

    return (
      <NavBarThree.Button
        key={item.key}
        className={active}
        onClick={() => onClick(item)}
      >
        {active && icon} {item.name}
      </NavBarThree.Button>
    )
  }

  const isActive = (key: ItemInterface['key']) => {
    return orderBy === key ? 'active' : '';
  }

  const renderClearBtn = () => {
    if (orderBy) {
      return (
        <NavBarThree.Button
          className='v-filter__order_by-clear'
          onClick={clear}
        >
          <CloseOutlined />
        </NavBarThree.Button>
      )
    }
  }

  return (
    <div className='v-filter__order_by'>
      <span className='v-filter__order_by-label'><span>Order by:</span></span>

      <NavBarThree type='type1'>
        {items.map(renderFilterItem)}
      </NavBarThree>

      {renderClearBtn()}
    </div>
  );
}

export default OrderBy;
